let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("h8Me2")).then(() => parcelRequire('kAj5d'));